import { useDispatch, useSelector } from "react-redux";
import {
  SettingOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { Menu, Modal, Form, Input, Button, Layout } from "antd";
import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { breadCrumbListAction, menuAction } from "hooks/actions/etcAction";
import { authAction } from "hooks/actions/mainAction";
import getMenuInfo from "controllers/getMenuInfo";
import axios from "axios";
import { languageAction } from "hooks/actions/systemAction";
import { openKeysAction } from "hooks/actions/etcAction";
import { selectkeysAction } from "hooks/actions/etcAction";

const backend = process.env.REACT_APP_BACKEND;

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
// const items = [
//   getItem("대시보드", "dashboard", <SettingOutlined />),
//   getItem("개인정보변경", "userinfo", <SettingOutlined />),
//   getItem("마스터", "master", <SettingOutlined />, [
//     getItem("권한설정", "master_setting"),
//     getItem(),
//   ]),
//   getItem(
//     "시스템 관리",
//     "sub5",
//     <SettingOutlined />,
//     [
//       getItem("Option 9", "9"),
//       getItem("Option 10", "10"),
//       getItem("Option 11", "11"),
//       getItem("Option 12", "12"),
//     ],
//     "group"
//   ),
//   getItem("정책 관리", "sub6", <SettingOutlined />, [
//     getItem("Option 13", "13"),
//     getItem("Option 14", "14"),
//     getItem("Option 15", "15"),
//     getItem("Option 16", "16"),
//   ]),
//   getItem("콘텐츠 관리", "sub7", <SettingOutlined />, [
//     getItem("Option 17", "17"),
//     getItem("Option 18", "18"),
//     getItem("Option 19", "19"),
//     getItem("Option 20", "20"),
//   ]),
// ];

// submenu keys of first level

const Sidebar = () => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.mainReducer.userInfo);
  const menuList = useSelector((state) => state.etcReducer.menuList);
  const menuGroupList = useSelector((state) => state.etcReducer.menuGroupList);
  const openR = useSelector(state=>state.etcReducer.openKeys) // 열려있는 메뉴그룹
  const selectR = useSelector(state=>state.etcReducer.selectKeys) // 열려있는 메뉴
  const dispatch = useDispatch();
  // const [openKeys, setOpenKeys] = useState([null]); // 열려있는 메뉴그룹
  // const [selectKeys, setSelectKeys] = useState([null]); // 열려있는 메뉴
  const [otpModal, setOtpModal] = useState([false, null]);
  const otpRef = useRef(null);
  const ref = useRef();
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const rootSubmenuKeys =
    menuGroupList &&
    menuGroupList.map(
      (menuGroup) =>
        "MG-" +
        menuGroup.id +
        "-" +
        ("00" + menuGroup.id).slice(-3) +
        "-" +
        menuGroup.menu_group_name +
        "-" +
        menuGroup.google_otp_use_yn
    ); // 마지막 여는 메뉴를 제외하고 닫기 위함
  // const needOtpMenu =
  //   menuGroupList &&
  //   menuGroupList.reduce((acc, cur) => {
  //     if (cur.google_otp_use_yn === "Y") {
  //       acc.push(
  //         "MG-" +
  //           cur.id +
  //           "-" +
  //           ("00" + cur.id).slice(-3) +
  //           "-" +
  //           cur.menu_group_name +
  //           "-" +
  //           cur.google_otp_use_yn
  //       );
  //     }
  //     return acc;
  //   }, []);

  // sidebar에 표시할 메뉴를 만드는 작업
  const items1 = !menuGroupList
    ? null
    : menuGroupList.map((menuGroup, idx) => {
        return getItem(
          menuGroup.menu_group_name,
          "MG-" +
            menuGroup.id +
            "-" +
            ("00" + menuGroup.id).slice(-3) +
            "-" +
            menuGroup.menu_group_name +
            "-" +
            menuGroup.google_otp_use_yn,
          <SettingOutlined />,
          // menuList.map((menu, id) => {
          //   if (menu.MenuGroup_id === menuGroup.id) {
          // return getItem(
          //   menu.menu_name,
          //   "ME-" +
          //     menu.Menu_id +
          //     "-" +
          //     ("00" + menu.id).slice(-3) +
          //     "-" +
          //     menu.menu_name +
          //     "-" +
          //     menu.menu_url
          // );
          //   }
          //   return null;
          // })
          menuList.reduce((acc, menu) => {
            if (menu.MenuGroup_id === menuGroup.id) {
              const group = getItem(
                menu.menu_name,
                "ME-" +
                  menu.Menu_id +
                  "-" +
                  ("00" + menu.id).slice(-3) +
                  "-" +
                  menu.menu_name +
                  "-" +
                  menu.menu_url
              );
              acc.push(group);
            }
            return acc;
          }, [])
        );
      });

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openR.indexOf(key) === -1);
    // console.log(latestOpenKey);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      // setOpenKeys(keys);
      dispatch(openKeysAction(keys))
    } else if (latestOpenKey.split("-")[4] === "N") {
      // setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
      dispatch(openKeysAction(latestOpenKey ? [latestOpenKey] : []))
    } else if (userInfo.google_otp_use_yn === "N") {
      Modal.warn({ title: "구글인증이 필요합니다. 구글인증기를 설치하세요." });
    } else {
      setOtpModal([true, latestOpenKey]);
    }
  };

  const onSelect = (keys) => {
    // setSelectKeys(keys.selectedKeys[0]);
    dispatch(selectkeysAction(keys.selectedKeys[0]))
  };

  function onClick({ key, keyPath, domEvent }) {
    axios
      .post(`${backend}/admin_menu/menu_history`, {
        menuId: Number(key.split("-")[1]),
      })
      .then((data) => {
        // console.log(data)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          Modal.error({
            title: "인증 에러",
            content: "인증이 만료되었습니다. 다시 로그인 해주세요.",
            afterClose: () => {
              dispatch(authAction(false, null));
            },
          });
        }
        console.log(err);
      });

    const path = key.split("-")[4].split("englemining.link")[1];

    let breadCrumbPath = ["HOME"];

    for (let i = keyPath.length - 1; i >= 0; i--) {
      breadCrumbPath.push(keyPath[i].split("-")[3]);
    }

    navigate(path);
    dispatch(breadCrumbListAction(breadCrumbPath));
  }

  function mfaHandleCancel() {
    setOtpModal([false, null]);
    otpRef.current.resetFields();
  }

  async function mfaHandleOK() {
    const otpCodeCheck = await otpRef.current
      .validateFields(["otpCode"])
      .then((res) => res)
      .catch((err) => err);

    if (otpCodeCheck.otpCode) {
      const otpCode = otpCodeCheck.otpCode;
      const email = userInfo.email;
      // console.log(otpCode,email)
      await axios
        .post(`${backend}/authentication/googleTOTP/menu_otp`, {
          email,
          otpCode,
        }) // 여기까지 그대로
        .then((data) => {
          let newKey = "";
          let breadCrumbPath = ["HOME"];
          let path = "";

          for (let i = 0; i < items1.length; i++) {
            if (items1[i].key === otpModal[1]) {
              newKey = items1[i].children[0].key;
              breadCrumbPath.push(
                items1[i].key.split("-")[3],
                newKey.split("-")[3]
              );
              path = newKey.split("-")[4].split("englemining.link")[1];
              break;
            }
          }

          navigate(path);
          dispatch(breadCrumbListAction(breadCrumbPath));
          // setSelectKeys(newKey);
          dispatch(selectkeysAction(newKey))
          // setOpenKeys(otpModal[1] ? [otpModal[1]] : []);
          dispatch(openKeysAction(otpModal[1] ? [otpModal[1]] : []))
          setOtpModal([false, null]);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            otpRef.current.setFields([
              {
                name: "otpCode",
                errors: ["인증번호가 일치하지 않습니다."],
              },
            ]);
          }
          console.log(err);
        });
    }
  }
  // console.log(openR)
  // console.log(selectR)
  const authCodeValidator = (_, value) => {
    const regExpCode = new RegExp(/^[0-9]{6}$/);
    if (!value) {
      return Promise.resolve();
    }
    if (regExpCode.test(value) === false) {
      return Promise.reject(new Error("인증코드 형식이 맞지 않습니다."));
    }
    return Promise.resolve();
  };

  useEffect(() => {
    getMenuInfo
      .userMenu()
      .then((data) => {
        if (data.length === 0) {
          dispatch(authAction(false, null));
        } else {
          dispatch(menuAction(data.userMenuGroupList, data.menuList));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dispatch]);

  useEffect(() => {
    axios
      .get(`${backend}/system_setting/language`)
      .then((data) => {
        dispatch(languageAction(data.data.data));
        // console.log(data.data.data)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          Modal.error({
            title: "인증 에러",
            content: "인증이 만료되었습니다. 다시 로그인 해주세요.",
            afterClose: () => {
              dispatch(authAction(false, null));
            },
          });
        }
        console.log(err);
      });
  }, []);

  return (
    <Layout
      style={{
        minWidth: collapsed ? "80px" : "220px",
        maxWidth: collapsed ? "80px" : "220px",
      }}
    >
      <Modal
        destroyOnClose={true}
        open={otpModal[0]}
        title="구글인증기"
        okText="확인"
        cancelText="취소"
        onOk={(e) => mfaHandleOK(e)}
        onCancel={mfaHandleCancel}
      >
        <Form ref={otpRef}>
          <Form.Item
            name="otpCode"
            validateTrigger={["onChange", "onBlur"]}
            rules={[
              {
                required: true,
                message: "구글인증기 코드를 입력하세요.",
              },
              {
                validator: authCodeValidator,
                validateTrigger: "onBlur",
              },
            ]}
          >
            <Input placeholder="구글인증기 인증 코드" />
          </Form.Item>
        </Form>
        <div>구글인증기에서 제시한 6자리의 숫자를 입력하세요.</div>
      </Modal>
      <Button
        type="default"
        onClick={toggleCollapsed}
        // style={{
        //   marginTop: 15,
        //   marginLeft: 20
        // }}
      >
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </Button>
      <Menu
        ref={ref}
        mode="inline"
        inlineCollapsed={collapsed}
        defaultOpenKeys={openR}
        defaultSelectedKeys={selectR}
        openKeys={openR}
        selectedKeys={selectR}
        onOpenChange={onOpenChange}
        onSelect={onSelect}
        onClick={onClick}
        items={items1}
      />
    </Layout>
  );
};
export default Sidebar;
